import api from './api'
import campaignsService from './campaignsService'
import { parseParams, transformChannelMetrics, parseUrlFilters } from './common'
import buildQuery from '@/utils/buildQuery'

export default {
  getChannelTypeStats ({ type }, filters = []) {
    const urlFilters = parseUrlFilters('dashboard', filters)
    return api.get(`/dashboard/channels/stats?type=${type}&${urlFilters}`).then(res => res.data)
      .then(data => {
        return {
          count: data.items,
          budget: data.budget,
          metrics: transformChannelMetrics(data.metrics),
          zones: data.zones
        }
      })
  },
  getChannelTypeStatsSummary ({ type }, filters = []) {
    filters = filters.filter(f => f.key !== 'campaign_channel_summary')
    const urlFilters = parseUrlFilters('dashboard_summary', filters)
    return api.get(`/dashboard/channels/stats/summary?type=${type}&${urlFilters}`).then(res => res.data)
      .then(data => {
        return {
          count: data.items,
          budget: data.budget,
          metrics: transformChannelMetrics(data.metrics),
          zones: data.zones
        }
      })
  },
  getStatsByCenters (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('dashboard_extended', filters)
    return api.get(`/dashboard/channels/stats/extended/centers?${urlParams}&${urlFilters}`)
      .then(res => res.data)
  },
  getStatsByCampaigns (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('dashboard_extended', filters)
    return api.get(`/dashboard/channels/stats/extended/campaigns?${urlParams}&${urlFilters}`)
      .then(res => res.data)
  },
  getStatsByAreaType (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('dashboard_extended', filters)
    return api.get(`/dashboard/channels/stats/extended/strategies?${urlParams}&${urlFilters}`)
      .then(res => res.data)
  },
  getStatsByProducts (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('dashboard_extended', filters)
    return api.get(`/dashboard/channels/stats/extended/products?${urlParams}&${urlFilters}`)
      .then(res => res.data)
  },
  getStatsYT (params, filters = []) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('dashboard_extended', filters)
    return api.get(`/dashboard/channels/stats/extended/yt?${urlParams}&${urlFilters}`, {
      headers: {
        'allowRequestDuplication': 'true'
      }
    })
      .then(res => res.data)
  },
  // necesary for extended dashboard campaigns table
  getCampaigns (params, filters) {
    filters = filters.concat({ key: 'campaign_channel', value: params.type })
    const extras = 'status=ACTIVE,FINISHED'
    return campaignsService.getCampaigns(params, filters, extras)
  },
  getCampaignsCSV (params, filters = []) {
    filters = filters.concat({ key: 'campaign_channel', value: params.type })
    const extras = 'status=ACTIVE,FINISHED'
    return campaignsService.getCampaignsCSV(params, filters, extras)
  },
  getLocations (params, filters = [], areaType) {
    const urlParams = parseParams(params)
    const urlFilters = parseUrlFilters('dashboard_map', filters)
    const urlMap = {
      adverts: '/adverts',
      pois: '/pois',
      zones: '/geo/postalcodes'
    }

    const url = urlMap[areaType]
    if (!url) {
      throw new Error(`
        [dashboardService.js getLocations] Error fetching locations: invalid area type "${areaType}".
        Valid types are ${Object.keys(urlMap).join(', ')}
      `)
    }

    return api.get(`${url}?${urlParams}&${urlFilters}`)
      .then(res => {
        const { query, meta, results } = res.data
        return {
          meta,
          data: results,
          query: buildQuery(query)
        }
      })
  },
  async getCampaignsBillingState () {
    const res = await api.get(`/campaigns/billing/state`)
    return res.data
  }
}
